import { createSelector } from '@reduxjs/toolkit';
import { selectContactByKey } from '../contacts/selectors';
/**
 * Identifies the company of the current search result, so callers can tell when a
 * search moved to a different company. Read it before dispatching the next result.
 */
export const selectCurrentCompanyKey = (state) => {
    var _a;
    const { company } = state.company;
    return ((_a = company === null || company === void 0 ? void 0 : company.company_lid) === null || _a === void 0 ? void 0 : _a.toString()) || (company === null || company === void 0 ? void 0 : company.fqdn) || '';
};
export const selectCompanySessionRequestId = (state) => state.company.requestId || '';
export const selectCompanySessionMaskId = (state) => state.company.maskId || '';
export const resolveKeys = (contacts, keys) => keys.map(key => selectContactByKey({ contacts }, key)).filter((contact) => Boolean(contact));
/**
 * Employees of the current company search, in result order. Replaces MST `Search.contacts`.
 *
 * Memoised on purpose: it builds a new array, so an unmemoised version hands every caller a new
 * reference on each call, which makes `useEffect([contacts])` fire on every render.
 */
export const selectProspectContacts = createSelector([(state) => state.contacts, (state) => state.company.employeeIds], resolveKeys);
/**
 * Employee whose profile is open. Replaces MST `Search.contact`, which fell back to
 * `keyPeople` when the id was not in the employee list.
 */
export const selectCurrentProspectContact = (state) => {
    const { currentEmployeeId } = state.company;
    if (!currentEmployeeId) {
        return undefined;
    }
    return selectContactByKey(state, currentEmployeeId);
};
export const selectProspectContactsCount = (state) => state.company.employeeIds.length;
